import { LevelType } from '@digibee/flow';

import { sendToBus } from '../../../../../components/Bus';
import { updateReactFlowWithStores } from '../../FlowCanvas/stores/reactFlowInstance';

import { changeLevel } from '~/scenes/Build/scenes/FlowBuilder/stores/helpers';

export const onChangeLevel = (
  nodeId: string | undefined,
  levelType: LevelType
) => {
  changeLevel({ levelType, componentId: nodeId });
  sendToBus({ event: { type: 'DESIGN.LEVEL_CHANGED' }, to: 'debugger' });
  updateReactFlowWithStores({ fitView: true });
};
